exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".image-viewer img{max-width:calc(100vw - 100px);max-height:calc(100vh - 420px)}", ""]);

